import { useState, useCallback, useEffect } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { apiCall } from '@/api/apiCall';
import OnStreetParkingPage from './Tabs/OnStreetParkingPage';
import OnStreetEnforcementPage from './Tabs/OnStreetEnforcementPage';
import CollectionDetails from './Tabs/CollectionDetails';

const OnStreetMap = () => {
  const [sharedCityName, setSharedCityName] = useState(null);
  const [sharedStreetInfo, setSharedStreetInfo] = useState(null); // 👈 NAYA

  const [sharedDateFilter, setSharedDateFilter] = useState({});
  const [pageReady, setPageReady] = useState(false); // 👈 NAYA — yeh track karega ke page ready hai ya nahi
  const [activeTab, setActiveTab] = useState('parking'); // 👈 NAYA — kaunsa tab currently visible/active hai

  // 👇 get-months-years — sirf aik dafa (yahan parent mein) fetch hogi, dono tabs
  // isi shared data ko reuse karengi (chahe Date Filter kitni bhi baar open/close ho)
  const [monthGroups, setMonthGroups] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [optLoading, setOptLoading] = useState(true);
  const [optError, setOptError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setOptLoading(true);
      setOptError(null);
      try {
        const res = await apiCall('get', '/get-months-years', null, null, false, false);
        if (cancelled) return;
        if (res?.success && res?.data) {
          setMonthGroups(res.data.months || []);
          setYearOptions((res.data.years || []).map(y => ({ value: y.name, label: y.name })).reverse());
        } else {
          setOptError('Could not load options');
        }
      } catch {
        if (!cancelled) setOptError('Could not load options');
      } finally {
        if (!cancelled) setOptLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, []);

  const handleCityChange = useCallback((city) => {
    setSharedCityName(city?.city_name || null);
  }, []);
  const handleStreetChange = useCallback((street) => {
  setSharedStreetInfo(
    street
      ? {
          streetCd: street.street_cd,
          streetName: street.street_name,
          streetSendName: street.street_send_name,
        }
      : null
  );
}, []);

  const handleContractChange = useCallback((label) => {
    setSharedCityName(label || null);
  }, []);

  const handleFiltersChangeExternal = useCallback((filters) => {
    setSharedDateFilter(filters || {});
  }, []);

  // 👇 NAYA — child (Parking page) yeh call karega jab wo ready ho jaye
  const handlePageReady = useCallback(() => {
    setPageReady(true);
  }, []);

  return (
    <Tabs
      defaultValue="parking"
      className="relative h-full w-full gap-0 bg-background"
      onValueChange={setActiveTab} // 👈 NAYA — jab bhi tab switch ho, activeTab update karo
    >

      {/* 👇 CHANGE — Tabs sirf tab dikhengi jab pageReady true ho */}
      {pageReady && (
        <TabsList className="absolute top-4 ml-82 z-50 shadow-md border border-border">
          <TabsTrigger value="parking">Parking</TabsTrigger>
          <TabsTrigger value="enforcement">Enforcement</TabsTrigger>
          <TabsTrigger value="collection">Current Status</TabsTrigger>
        </TabsList>
      )}

      <TabsContent value="parking" forceMount className="h-full m-0 data-[state=inactive]:hidden">
       <OnStreetParkingPage
  onCityChange={handleCityChange}
  onStreetChange={handleStreetChange}
  selectedCityNameExternal={sharedCityName}
  selectedStreetInfoExternal={sharedStreetInfo}
  onFiltersChangeExternal={handleFiltersChangeExternal}
  selectedDateFilterExternal={sharedDateFilter}
  onReady={handlePageReady}
  isActive={activeTab === 'parking'}
  monthGroups={monthGroups}
  yearOptions={yearOptions}
  optLoading={optLoading}
  optError={optError}
/>
      </TabsContent>

      <TabsContent value="enforcement" forceMount className="h-full m-0 data-[state=inactive]:hidden">
        <OnStreetEnforcementPage
          selectedCityName={sharedCityName}
          selectedDateFilter={sharedDateFilter}
          onContractChange={handleContractChange}
          onFiltersChangeExternal={handleFiltersChangeExternal}
          isActive={activeTab === 'enforcement'} // 👈 NAYA — sirf active hone par hi fetch karega
          monthGroups={monthGroups}
          yearOptions={yearOptions}
          optLoading={optLoading}
          optError={optError}
        />
      </TabsContent>

      <TabsContent value="collection" forceMount className="h-full m-0 data-[state=inactive]:hidden">
       <CollectionDetails
  onCityChange={handleCityChange}
  onStreetChange={handleStreetChange}
  selectedCityNameExternal={sharedCityName}
  selectedStreetInfoExternal={sharedStreetInfo}
  onFiltersChangeExternal={handleFiltersChangeExternal}
  selectedDateFilterExternal={sharedDateFilter}
  isActive={activeTab === 'collection'}
  monthGroups={monthGroups}
  yearOptions={yearOptions}
  optLoading={optLoading}
  optError={optError}
/>
      </TabsContent>

    </Tabs>
  );
};

export default OnStreetMap;